import React,{useEffect} from 'react'
import { Link,useNavigate } from 'react-router-dom'
import Logo from '../../assets/images/logo.png'
import StudentImg from '../../assets/images/login-students.png'
import LoginVector from '../../assets/images/login-vector.png'
import ForgotPasswordForm from '../../components/Auth/ForgotPasswordForm'

const ForgotPassword = () => {
    const navigate = useNavigate();

    useEffect(() => {
        if(sessionStorage.getItem('token')){
            navigate('/student/dashboard');
        }
    },[])

  return (
    <div className="login_page ">
        <div className="container">
            <div className="row login_register_form justify-content-between align-items-center">
                <div className="col-lg-12">
                    
                </div>
                <div className="col-lg-5">
                    <div className="login_left">
                        <img src={Logo} className="img-fluid" alt="Logo"/>
                        {/* <h1>Welcome Student</h1>*/}
                        <h2>Forgot Password?</h2> 

                        <p className='d-flex align-items-center'><Link to="/login" className="text-decoration-none text-primary fw-bold" title="Back to Login"> 
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" style={{marginTop:'-2px'}} fill="currentColor" className="bi bi-arrow-left-circle-fill me-2" viewBox="0 0 16 16">
  <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z"/>
</svg>
                        Back to Login</Link></p>
                        <ForgotPasswordForm/>
                    </div>
                </div>

                <div className="col-lg-6 d-none d-lg-block align-self-stretch position-relative">
                    <div className="login_student_col position-relative">
                        <img src={StudentImg} alt="Student pic"/>
                        <h2>Welcome to ALLEN Overseas</h2>
                        <p>Your Partner in Education</p>
                    </div>

                    {/* <img src={LoginVector} className="img-fluid login_vector_img" alt="vector img"/> */}
                </div>
            </div>
        </div>
    </div>
  )
}

export default ForgotPassword